import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import '../Styles/message.css';

function AzedMessage()
{ const [formData,setFormData] = useState({ nom:'', email:'', msg:'' });
  const navigate = useNavigate();
  const { t } = useTranslation();

  function Changer (e)
  { let {name,value} = e.target; 
    setFormData({...formData,[name] : value }); }

  function Valider(e) 
  { e.preventDefault();
    //let message = `Votre nom : ${formData.nom} Votre email : ${formData.email} Votre message : ${formData.msg} : ${t(`Messaging.Active`)}`;
    let message = `${t(`Messaging.Active`)}`;
    /*alert('Votre message : ' + message);*/
    alert(message);
    setFormData({ nom: '', email: '', msg: '' });
    navigate("/")
  }
 return(  <form onSubmit={Valider}>
            <div><label htmlFor="nom">{t(`NewContact.Name`)}&nbsp;:&nbsp;</label>
                 <input type="text" id="nom" name="nom" value={formData.nom} onChange={Changer} />
            </div>
            <div><label htmlFor="email">{t(`NewContact.Email`)}&nbsp;:&nbsp;</label>
                 <input type="email" id="email" name="email" value ={formData.email} onChange={Changer} />
            </div>
            <div><label htmlFor="message">{t(`Messaging.MSG`)}&nbsp;:&nbsp;</label>
                 <textarea id="msg" name="msg" value={formData.msg} onChange={Changer} />
            </div>
            <div><button style={{margin: 'auto', }} type="submit">{t(`Messaging.Send`)}</button>
                 <button style={{marginLeft: '220px'}} 
                         onClick={() => navigate("/")}>{t(`Messaging.Back`)}
                 </button>
            </div>     
         </form> 
       )
}

export default AzedMessage;